const activities = [
    'Take a romantic walk on the beach',
    'Go for a picnic in the park',
    'Visit a local art gallery',
    'Take a cooking class together',
    'Have a movie marathon at home',
    'Go hiking in a nearby nature reserve.',
    'Explore a farmers market and cook a meal with your findings.',
    'Have a game night with board games or video games.',
    'Take a scenic drive to enjoy the countryside.',
    'Go for a bike ride in a scenic area',
    'Have a karaoke night at home or at a local bar.',
    'Take a pottery or painting class.',
    'Visit a local museum.',
    'Go on a mini road trip to a nearby town or city.',
    'Have a DIY spa day at home.',
    'Go wine tasting at a local vineyard.',
    'Attend a live music concert.',
    'Take a dance class together.',
    'Volunteer at a local charity or community event.',
    'Explore a nearby botanical garden.',
    'Go on a hot air balloon ride.',
    'Have a bonfire and make smores.',
    'Take a scenic boat ride or cruise.',
    'Visit an amusement park or fair.',
    'Go horseback riding.',
    'Attend a local theater performance.',
    'Go ice skating or roller skating.',
    'Take a scenic train ride.',
    'Explore a local flea market or antique fair.',
    'Go stargazing in a remote area.',
    'Have a themed dinner night at home.',
    'Take a photography walk and capture interesting sights.',
    'Visit a nearby zoo or animal sanctuary.',
    'Go kayaking or canoeing.',
    'Take a yoga or meditation class together.',
    'Go for a swim at a local pool or beach.',
    'Attend a comedy show or open mic night.',
    'Go camping in a scenic location.',
    'Visit a nearby botanical garden.',
    'Go on a ghost tour or haunted house adventure.',
    'Have a picnic in a beautiful garden.',
    'Go for a scenic helicopter or airplane ride.',
    'Explore a local bookstore or library.',
    'Take a scenic train ride through the countryside.',
    'Go rock climbing or indoor bouldering.',
    'Attend a local sports game or event.',
    'Go on a brewery or winery tour.',
    'Visit a nearby historical site or landmark.',
    'Go for a scenic sunset or sunrise hike.',
    'Have a DIY pizza-making night at home.',
    'Take a pottery or ceramics class together.',
    'Go fruit picking at a local farm.',
    'Attend a cooking or mixology workshop.',
    'Take a scenic bike ride along a river or lake.',
    'Visit an escape room and solve puzzles together.',
    'Go to a local trivia night at a bar or restaurant.',
    'Have a picnic and fly kites in a park.',
    'Take a scenic drive and visit nearby landmarks.',
    'Go snorkeling or scuba diving.',
    'Attend a local music festival or outdoor concert.',
    'Explore a nearby nature trail or hiking path.',
    'Take a day trip to a nearby beach or lake.',
    'Go for a tandem bike ride.',
    'Have a DIY wine and cheese tasting at home.',
    'Take a painting or drawing class together.',
    'Visit a nearby farm and interact with animals.',
    'Go on a scenic horse-drawn carriage ride.',
    'Attend a dance performance or ballet.',
    'Have a picnic and fly remote-controlled airplanes.',
    'Take a pottery or ceramics class together.',
    'Go bird watching in a local park or wildlife reserve.',
    'Take a scenic helicopter tour of your city.',
    'Visit a nearby science or technology museum.',
    'Go for a romantic dinner cruise.',
    'Attend a local food festival or culinary event.',
    'Have a beach bonfire and roast marshmallows.',
    'Take a scenic ferry ride to a nearby island.',
    'Go for a paddleboarding or kayaking adventure.',
    'Have a DIY ice cream sundae night at home.',
    'Visit a nearby aquarium or marine park.',
    'Go on a photography excursion to capture stunning landscapes.',
    'Take a scenic hot air balloon ride at sunrise.',
    'Attend a local art or craft fair.',
    'Have a picnic and fly paper airplanes.',
    'Go for a scenic motorcycle ride.',
    'Take a scenic boat tour or river cruise.',
    'Go for a romantic dinner at a rooftop restaurant.',
    'Visit a nearby observatory for stargazing.',
    'Have a DIY outdoor movie night in your backyard.',
    'Take a guided tour of a local historical site.',
    'Go for a scenic train ride through the mountains.',
    'Attend a local dance or music performance.',
    'Have a picnic and play frisbee or catch.',
    'Go for a wine and cheese tasting at a local vineyard.',
    'Take a pottery or ceramics class together.',
    'Visit a nearby nature reserve and go bird watching.',
    'Go for a romantic dinner at a candlelit restaurant.',
    'Take a scenic helicopter ride at sunset.',
    'Attend a local poetry reading or spoken word event.',
    'Have a picnic and fly a kite on a windy day.'
]

export default activities;
